import { dateTimeToString, emptyStrIfNull, numberToString } from '../utils/Functions';
import { BaseController } from './BaseController';

export default class PackageController extends BaseController {
   constructor(props) {
      super(props);
      this.name = 'PackageController';
   }

   getTitulosDaTabela = () => {
      return [
         { titulo: this.lang.codigo, orderby: 'Id', className: 'codigo' },
         { titulo: 'Data de inclusão', width: '15%', orderby: 'dataDeInclusao' },
         { titulo: 'Data da leitura', width: '15%', orderby: 'dataDaLeitura' },
         { titulo: 'Gateway', width: '15%', orderby: 'gateway' },
         { titulo: 'TAG', width: '15%', orderby: 'tag', className: '' },
         { titulo: 'Distância', width: '8%', orderby: 'distancia', className: 'right' },
         { titulo: 'Bateria', width: '8%', orderby: 'bateria', className: 'right' },
         { titulo: 'Temperatura', width: '8%', orderby: 'temperatura', className: 'right' },
         { titulo: 'Umidade', width: '8%', orderby: 'umidade', className: 'right' },
         { titulo: 'Porta', width: '8%', orderby: 'porta', className: 'right' },
      ];
   };

   getDadosDaTabela = (item) => {
      return [
         item.id,
         <span style={{ wordBreak: 'break-all' }}>{dateTimeToString(item.dataDeInclusao)}</span>,
         <span style={{ wordBreak: 'break-all' }}>{dateTimeToString(item.dataDaLeitura)}</span>,
         item.gateway,
         item.mac,
         item.distancia != null ? numberToString(item.distancia) + 'm' : '',
         item.bateria != null ? item.bateria + 'v' : '',
         emptyStrIfNull(numberToString(item.temperatura)) + (item.temperatura != null ? 'ºC' : ''),
         emptyStrIfNull(numberToString(item.umidade)) + (item.umidade != null ? '%' : ''),
         item.porta,
      ];
   };

   getObjetoDeDados = () => {};
}
